<template>
    <div v-if="loaded">
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        :options="form.tipos"
                        :validations="validations.tipo"
                        label="Tipo"
                        show-default-option
                        text-field="nome"
                        v-model="model.tipoId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="9">
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <StatusPara :data="{ form, model }" />

        <rkm-row>
            <rkm-col>
                <rkm-form-checkbox v-model="model.ativo">
                    Ativo
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components
import StatusPara from './components/status-para/Index'

// Mixins.
import { error, object, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { StatusPara },
    computed: {
        validations() {

            return {
                tipo: { required: true },
                nome: { required: true, min: 3, max: 100 },
            }
        },
    },
    created() {

        this.repositories = {
            status: this.getConectaSusRepository('regulacao.status'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            const repository = this.id
                ? this.repositories.status.edit(this.id)
                : this.repositories.status.create()

            repository
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const repository = this.id
                        ? this.repositories.status.update(this.id, this.prepareData())
                        : this.repositories.status.store(this.prepareData())

                    repository
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.statusPara = data.statusPara.map(s => s.id)

            return this.camelObjectKeysToSnakeRecursive(data)
        }
    },
    mixins: [error, object, repository, stringCase],
    props: {
        id: { type: Number },
    },
}
</script>